import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // Pastikan jspdf-autotable sudah terinstal dan diimport
import { formatTanggal, formatRupiah, capitalizeWords } from "../../../Utils"; // Asumsikan utilitas ini tersedia

const generateHarianHarirayaPDF = (data, tglmulai, tglakhir) => {
  // --- START: Validasi Data ---
  // Pastikan 'data' adalah array. Jika tidak, inisialisasi dengan array kosong.
  const actualData = Array.isArray(data) ? data : [];

  // Jika tidak ada data, fungsi akan berhenti di sini.
  // Pesan alert akan ditangani di komponen pemanggil.
  if (actualData.length === 0) {
    return;
  }
  // --- END: Validasi Data ---

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};
const drawHeader = (logoDataUrl) => {
  const logoX = 10;
  const logoY = 10;
  const logoSize = 15;
  const textX = logoX + logoSize + 2;

  if (logoDataUrl) {
    try {
      const imgType =
        typeof logoDataUrl === "string" &&
        logoDataUrl.startsWith("data:image/png")
          ? "PNG"
          : "JPEG";

      doc.addImage(
        logoDataUrl,
        imgType,
        logoX,
        logoY,
        logoSize,
        logoSize
      );
    } catch (e) {
      console.warn("Gagal menambahkan logo:", e);
    }
  }

  const textY = logoY + logoSize / 2 - 1;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("KPRI SRI REJEKI", textX, textY);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No. 164 Kab.Malang", textX, textY + 5);

  const lineY = logoY + logoSize + 4;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);

  const reportY = lineY + 6;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text(
    "Laporan Harian Simpanan Hari Raya",
    pageWidth / 2,
    reportY,
    {
      align: "center",
    }
  );

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    `Tanggal : ${formatTanggal(tglmulai)} s/d ${formatTanggal(tglakhir)}`,
    pageWidth / 2,
    reportY + 5,
    {
      align: "center",
    }
  );

  return reportY + 9;
};
  

  // Header Kolom Tabel
  const headers = [[
    { content: "No.", styles: { halign: "left" } },
    { content: "Tanggal", styles: { halign: "center" } },
    { content: "No.Transaksi", styles: { halign: "center" } },
    { content: "No.Anggota", styles: { halign: "center" } },
    { content: "Nama", styles: { halign: "left" } },
    { content: "Transaksi", styles: { halign: "left" } },
    { content: "Debet", styles: { halign: "right" } },
    { content: "Kredit", styles: { halign: "right" } },
  ]];

  let totalDebet = 0;
  let totalKredit = 0;

  // Data Baris Tabel
  let tableData = actualData.map((item, index) => {
    // Pastikan nilai adalah angka sebelum dijumlahkan
    totalDebet += parseFloat(item.debet) || 0;
    totalKredit += parseFloat(item.kredit) || 0;

    return [
      { content: index + 1, styles: { halign: "right" } },
      // Gunakan nullish coalescing operator (?? "-") untuk menampilkan "-" jika data null/undefined
      { content: formatTanggal(item.tgltransak) ?? "-", styles: { halign: "center" } },
      { content: item.notransaksi ?? "-", styles: { halign: "center" } },
      { content: item.noanggota ?? "-", styles: { halign: "center" } },
      capitalizeWords(item.nama) ?? "-",
       { content: item.kdtrans === '1' ? "Setoran" :
                 item.kdtrans === '2' ? "Penarikan" : 
                 item.kdtrans === '3' ? "Jasa" :
                 "-", styles: { halign: "left" } },
      { content: formatRupiah(item.debet), styles: { halign: "right" } },
      { content: formatRupiah(item.kredit), styles: { halign: "right" } }
    ];
  });

  // Tambahkan baris total di akhir tabel
  tableData.push([
    {
      content: "Total Keseluruhan",
      colSpan: 6, // Kolom digabung dari 'No.' sampai 'Transaksi'
      styles: {
        fontStyle: "bold",
        halign: "center",
        fillColor: [230, 230, 230], // Warna latar belakang untuk baris total
      }
    },
    {
      content: formatRupiah(totalDebet),
      styles: {
        fontStyle: "bold",
        halign: "right",
        fillColor: [230, 230, 230],
      }
    },
    {
      content: formatRupiah(totalKredit),
      styles: {
        fontStyle: "bold",
        halign: "right",
        fillColor: [230, 230, 230],
      }
    }
  ]);
  // Konfigurasi AutoTable
  const renderTableAndExport = (startY) => {
  autoTable(doc, {
    head: headers,
    body: tableData,
    startY: startY,
    theme: "grid",

    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      overflow: "linebreak",
    },

    headStyles: {
      halign: "center",
      valign: "middle",
      fontSize: 8,
      cellPadding: 2,
      fillColor: [0, 191, 165],
      textColor: 255,
    },

    showHead: "everyPage",

    margin: {
      left: 8,
      right: 8,
      top: 20,
      bottom: 10,
    },

    tableWidth: "stretch",

    columnStyles: {
      0: { cellWidth: 10, halign: "right" },
      1: { cellWidth: 20, halign: "center" },
      2: { cellWidth: 25, halign: "center" },
      3: { cellWidth: 25, halign: "center" },
      4: { cellWidth: "auto", halign: "left", overflow: "linebreak" },
      5: { cellWidth: 25, halign: "left" },
      6: { cellWidth: 25, halign: "right" },
      7: { cellWidth: 25, halign: "right" },
    },

    didDrawPage: (data) => {
      let str = "Page " + doc.internal.getNumberOfPages();

      doc.setFontSize(8);
      doc.text(
        str,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  window.open(pdfUrl, "_blank");
};

const customLogoUrl =
  window.location.origin + "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    const startY = drawHeader(logoDataUrl);
    renderTableAndExport(startY);
  })
  .catch(() => {
    const startY = drawHeader();
    renderTableAndExport(startY);
  });

};

export default generateHarianHarirayaPDF;